import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotController } from '../../controllers/slots-ng-controller';
import { ResizeController } from '../../controllers/resize-controller';
import { screenSizeMap } from '../../controllers/screen-size-controller';
import componentStyles from './sic-hero.css.lit';

/* @todo update custom ranges on the resize controller*/
// import tokens from '../../../../dist/tokens.default.json';

/**
 * The SicHero component
 * @element sic-hero
 *
 * @slot hero-image - image slot
 * @slot eyebrow - eyebrow slot
 * @slot heading - heading slot
 * @slot body - body slot
 * @slot cta - cta slot
 *
 */

@customElement('sic-hero')
export class LandingHero extends OutlineElement {
  slots = new SlotController(this);
  static styles: CSSResultGroup = [componentStyles];

  resizeController = new ResizeController(this, {
    breakpoints: [
      screenSizeMap.get('sm') as number,
      screenSizeMap.get('md') as number,
      screenSizeMap.get('lg') as number,
      screenSizeMap.get('xl') as number,
      screenSizeMap.get('xxl') as number,
    ],
  });

  render(): TemplateResult {
    const rangeClass = {
      range1: this.resizeController.currentBreakpointRange === 0,
      range2: this.resizeController.currentBreakpointRange === 1,
      range3: this.resizeController.currentBreakpointRange === 2,
      range4: this.resizeController.currentBreakpointRange === 3,
      range5: this.resizeController.currentBreakpointRange === 4,
      range6: this.resizeController.currentBreakpointRange === 5,
    };

    return html`
      <div class="landing-hero-wrapper ${classMap(rangeClass)}">
        <sic-container
          container-width="full"
          background-color="primary-default"
          top-padding="none"
          bottom-padding="none"
          x-padding="none"
        >
          <sic-container
            class="hero-wrapper ${classMap(rangeClass)}"
            top-padding="none"
            bottom-padding="none"
            container-width="normal"
          >
            <div class="content-wrapper ${classMap(rangeClass)}">
              ${this.resizeController.currentBreakpointRange === 0 ||
              this.resizeController.currentBreakpointRange === 1 ||
              this.resizeController.currentBreakpointRange === 2
                ? html`${this.slots.conditionalSlot('hero-image')}`
                : html``}
              <div class="text-wrapper">
                <sic-styled-text class="text">
                  ${this.slots.conditionalSlot('eyebrow')}
                  ${this.slots.conditionalSlot('heading')}
                  ${this.slots.conditionalSlot('body')}
                </sic-styled-text>
                ${this.slots.conditionalSlot('cta', false)}
              </div>
              ${this.resizeController.currentBreakpointRange === 3 ||
              this.resizeController.currentBreakpointRange === 4 ||
              this.resizeController.currentBreakpointRange === 5
                ? html`${this.slots.conditionalSlot('hero-image')}`
                : html``}
            </div>
          </sic-container>
        </sic-container>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-hero': LandingHero;
  }
}
